module.exports = __webpack_public_path__ + "static/c1-5871855c7d7fc800368a3ad45554dd7a.jpg";